<template>
	<div class="index nobg" v-loading="loading">
		<HeaderInc ref="ref_header" :info="info"></HeaderInc>
		<div class="warp main_body">
			<div class="left_mune">
				<ul>
					<li class="active">
						<img src="../assets/ico_3.png" />
						个人设置
					</li>
					<li @click="gowork">
						<img src="../assets/ico_4.png" />
						作品管理
					</li>
					<li @click="gocer">
						<img src="../assets/ico_7.png" />
						证书查询
					</li>
				</ul>
			</div>
			<div class="main_content">
				<h1>>个人信息</h1>
				<div class="main_content_g">
					<el-form ref="reg_form" :model="info" :rules="rules" v-show="step == 1" status-icon
						label-width="90px" class="demo-ruleForm">
						<div class="avatar-upload-box" prop="avatar">
							<el-upload action="" :show-file-list="false"
								:before-upload="beforeAvatarUpload">
								<img v-if="info.avatar" :src="info.avatar" class="avatar" />
								<img v-else src="../assets/avater.jpg" class="avatar" />
							</el-upload>
							<span>头像:180*180的jpg格式</span>
						</div>
						<el-form-item label="身份" prop="type">
							<el-radio-group v-model="info.type">
								<el-radio :label="0">学生</el-radio>
								<el-radio :label="1">老师</el-radio>
								<el-radio :label="2">设计师</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="真实姓名" prop="name">
							<el-input v-model="info.name" type="text" placeholder="请输入真实姓名" autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="国籍" prop="country">
							<el-input v-model="info.country" type="text" placeholder="请输入国籍" autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="身份证" prop="sfcode">
							<el-input v-model="info.sfcode" type="text" placeholder="请输入身份证号" autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="邮箱" prop="email">
							<el-input v-model="info.email" type="text" placeholder="请输入电子邮箱" autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="联系地址" prop="address">
							<el-input v-model="info.address" type="textarea" placeholder="请输入详细联系地址"></el-input>
						</el-form-item>
						<el-form-item label="QQ">
							<el-input v-model="info.qq" type="text" placeholder="您的QQ" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="微信">
							<el-input v-model="info.wechat" type="text" placeholder="您的微信" autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="开户行">
							<el-input v-model="info.bankname" type="text" placeholder="请详细到具体支行" autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="银行卡号">
							<el-input v-model="info.bankcode" type="text" placeholder="用于奖金下发" autocomplete="off">
							</el-input>
						</el-form-item>
					</el-form>

					<el-form ref="xx_form0" :model="info" :rules="rules" v-show="info.type==0" status-icon
						label-width="90px" class="demo-ruleForm">
						<el-form-item label="学校" prop="school_id">
							<el-select v-model="info.school_id" filterable placeholder="请选择学校~" @change="school_change">
								<el-option v-for="item in options" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="学院" prop="college_id">
							<el-select v-model="info.college_id" filterable placeholder="请选择学院~">
								<el-option v-for="item in college" :label="item.name" :value="item.id">
								</el-option>
							</el-select><span class="college_tishi">1.如果没有找到你的“学院”，请选择【个人参赛】，“非命题赛”报名费自理。<br>
								2.如果是单位/学院“统一集中缴费/参赛”，请选择【具体学院名称】，如“艺术与设计学院”，“非命题赛”报名费一般由学院“统一支付”。</span>
							<el-input v-show="info.college_id == 0" v-model="info.qita" type="text" placeholder="学院名字"
								autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="系部">
							<el-input v-model="info.xibu" type="text" placeholder="请输入您所在系部" autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="专业">
							<el-input v-model="info.zhuanye" type="text" placeholder="请输入您的所属专业" autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="学历" prop="xueli">
							<el-select v-model="info.xueli" filterable placeholder="请选择学历~">
								<el-option v-for="item in xuelioption" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="入学年份">
							<el-date-picker v-model="info.school_year" type="year" format="YYYY" :validate-event="false"
								placeholder="请选择"></el-date-picker>
						</el-form-item>
						<el-form-item>
							<a class="button_1" @click="submitForm">保存</a>
						</el-form-item>
					</el-form>

					<el-form ref="xx_form1" :model="info" :rules="rules" v-show="info.type==1" status-icon
						label-width="90px" class="demo-ruleForm">
						<el-form-item label="学校" prop="school_id">
							<el-select v-model="info.school_id" filterable placeholder="请选择学校~" @change="school_change">
								<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="学院" prop="college_id">
							<el-select v-model="info.college_id" filterable placeholder="请选择学院~">
								<el-option v-for="item in college" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="系部" prop="xibu">
							<el-input v-model="info.xibu" type="text" placeholder="请输入您所在系部" autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="专业" prop="zhuanye">
							<el-input v-model="info.zhuanye" type="text" placeholder="请输入您的所属专业" autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="职称" prop="zhicheng">
							<el-input v-model="info.zhicheng" type="text" placeholder="请输入您的职称" autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="职务">
							<el-input v-model="info.zhiwu" type="text" placeholder="请输入您的职务" autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="社会兼职">
							<el-input v-model="info.jianzhi" type="textarea" placeholder="请输入您的社会兼职"></el-input>
						</el-form-item>
						<el-form-item>
							<a class="button_1" @click="submitForm">保存</a>
						</el-form-item>
					</el-form>

					<el-form ref="xx_form2" :model="info" :rules="rules" v-show="info.type==2" status-icon
						label-width="90px" class="demo-ruleForm">
						<el-form-item label="工作单位" prop="company">
							<el-input v-model="info.company" type="text" placeholder="请输入您的工作单位" autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="职务">
							<el-input v-model="info.zhiwu" type="text" placeholder="请输入您的职务" autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="学校" prop="school_id">
							<el-select v-model="info.school_id" filterable placeholder="请选择学校~">
								<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
								<el-option key="0" label="其他" value="0"></el-option>
							</el-select>
							<el-input v-show="info.school_id==0" v-model="info.qita" type="text" placeholder="请输入您的学院"
								autocomplete="off">
							</el-input>
						</el-form-item>
						<el-form-item label="学历" prop="xueli">
							<el-select v-model="info.xueli" filterable placeholder="请选择学历~">
								<el-option v-for="item in xuelioption" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<a class="button_1" @click="submitForm">保存</a>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>

		<el-dialog v-model="centerDialogVisible" title="温馨提示" width="45%" destroy-on-close center>
			<div class="info_contact">
				<span>1. 如果没有找到你的“学院”，请选择【个人参赛】</span>
				<span>2. 所有赛道均免收参赛费，报名成功即默认完成缴费。</span>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="centerDialogVisible = false">关闭</el-button>
				</span>
			</template>
		</el-dialog>

	</div>
</template>

<script>
	import httpUtil from '@/util/HttpRequestUtil'
	import HeaderInc from '@/components/HeaderInc.vue'
	import OSS from 'ali-oss'
	export default {
		name: 'Home',
		components: {
			HeaderInc
		},
		props: {},
		data() {
			return {
				info: {
					token: '',
					avatar: '',
					name: ''
				},
				rules: {
					name: [{
							required: true,
							message: '请输入姓名',
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								// 使用正则表达式验证姓名是否仅包含中英文字符
								if (/[\u4e00-\u9fa5a-zA-Z·]+$/.test(value)) {
									callback();
								} else {
									callback(new Error('姓名只能包含中英文字符！'));
								}
							},
							trigger: 'blur'
						}
					],
					country: [{
						required: true,
						message: '请输入国籍',
						trigger: 'blur'
					}],
					sfcode: [{
						required: true,
						message: '请输入身份证号',
						trigger: 'blur'
					}, {
						min: 18,
						max: 18,
						message: '长度在18个数字',
						trigger: 'blur'
					}],
					email: [{
						required: true,
						message: '请输入电子邮箱',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '请输入联系地址',
						trigger: 'blur'
					}],
					school_id: [{
						required: true,
						message: '请选择学校',
						trigger: 'blur'
					}],
					college_id: [{
						required: true,
						message: '请选择学院',
						trigger: 'blur'
					}],
					xibu: [{
						required: true,
						message: '请填写系部',
						trigger: 'blur'
					}],
					zhuanye: [{
						required: true,
						message: '请填写专业',
						trigger: 'blur'
					}],
					zhicheng: [{
						required: true,
						message: '请填写职称',
						trigger: 'blur'
					}],
					xueli: [{
						required: true,
						message: '请选择学历',
						trigger: 'blur'
					}],
					company: [{
						required: true,
						message: '请输入工作单位',
						trigger: 'blur'
					}],
					type: [{
						required: true,
						message: '请选择身份',
						trigger: 'blur'
					}],
				},
				loading: false,
				step: 1,
				options: [],
				options_child: [],
				college: [],
				xuelioption: [{
					id: '0',
					name: '博士'
				}, {
					id: '1',
					name: '硕士'
				}, {
					id: '2',
					name: '本科'
				}, {
					id: '3',
					name: '专科'
				}, {
					id: '4',
					name: '其他'
				}],
				centerDialogVisible: false,
				// OSS配置
				ossConfig: {
					region: 'oss-cn-shenzhen',
					accessKeyId: 'LTAI5tGZdXHkWmmE4VhdjHx8',
					accessKeySecret: 'ESvQ0dKpEA59Bj1f1q1BBCmxTjRX2S',
					bucket: 'oda20260204'
				},
				uploadingAvatar: false
			}
		},
		created() {
			this.getuserdata()
			this.getbasedata()
		},
		methods: {
			submitForm() {
				var that = this;
				that.$refs['reg_form'].validate((valid) => {
					if (valid) {
						that.$refs['xx_form' + that.info.type].validate((valid) => {
							if (valid) {
								let data = that.info
								data.ac = 'saveinfo'
								httpUtil.post('/api/', data, function(res) {
									if (res.status == 1) {
										that.$message({
											showClose: true,
											message: '保存成功，一秒后跳转到作品管理页面~',
											type: 'success'
										})
										setTimeout(function() {
											that.$router.push({
												name: 'Work'
											})
										}, 900)
									} else {
										that.$message.error('网络超时~请重试')
									}
								})
							} else {
								that.$message.error('请将信息填写完整~')
								return false
							}
						})
					} else {
						that.$message.error('请将信息填写完整~')
						return false
					}
				})
			},
			goBack() {
				var that = this;
				if (that.step == 1) {
					that.$router.isBack = true
					that.$router.push({
						name: 'Index'
					})
				} else {
					that.step = that.step - 1;
				}
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg'
				const isLt2M = file.size < 1024 * 500

				if (!isJPG) {
					this.$message.error('请上传jpg图片格式~')
					return false
				}
				if (!isLt2M) {
					this.$message.error('头像保持500k以下~')
					return false
				}

				var that = this
				that.uploadingAvatar = true

				let date = new Date()
				let path = httpUtil.formatDate(date, 'yyyyMMdd')
				let filename = date.valueOf() + '_' + parseInt(Math.random() * (9999 - 1000 + 1) + 1000, 10) + '.jpg'

				var client = new OSS(that.ossConfig)

				client.put('avatar/' + path + '/' + filename, file).then(function(res) {
					that.info.avatar = 'https://oss.oda.org.cn/' + res.name

					// 保存头像到后端
					let data = {}
					data.avatar = that.info.avatar
					data.token = that.info.token
					data.ac = 'setavatar'
					httpUtil.post('/api/', data, function(res) {
						if (res.status == 1) {
							that.$message({
								showClose: true,
								message: '头像设置完成~',
								type: 'success'
							})
						} else {
							that.$message.error(res.msg)
						}
						that.uploadingAvatar = false
					})
				}).catch((err) => {
					console.log(err)
					that.$message.error('头像上传失败，请重试')
					that.uploadingAvatar = false
				})

				return false
			},
			getuserdata() {
				var that = this
				var userinfo = JSON.parse(localStorage.getItem('userinfo')) || [];
				if (!userinfo.token) {
					that.gologin()
					return false
				}
				let data = {}
				data.ac = 'getuserinfo'
				data.token = userinfo.token
				httpUtil.post('/api/', data, function(res) {
					if (res) {
						that.info = res
						that.info.type = parseInt(res.type)
						if (that.info.school_id == 0) {
							that.info.school_id = ''
						}
						if (that.info.match_id > 0) {
							that.$messageBox.alert(
								'尊贵的特邀设计师，欢迎参加米兰设计周中国设计展！',
								'欢迎您', {

								}
							)
						}
					} else {
						that.gologin()
						return false
					}
				})
			},
			getbasedata() {
				var that = this
				let data = {}
				data.ac = 'school_basedata'
				httpUtil.post('/api/', data, function(res) {
					if (res) {
						that.options = res.list_1
						that.options_child = res.list_2
						if (that.info.school_id > 0) {
							that.school_change()
						}
					}
				})
			},
			gologin() {
				var that = this
				that.$router.isBack = true
				that.$router.push({
					name: 'Index'
				})
			},
			school_change() {
				var that = this
				let college = []
				for (let i in that.options_child) {
					if (that.options_child[i].school_id == that.info.school_id) {
						college.push(that.options_child[i])
					}
				}
				college.push({
					id: 0,
					name: '个人参赛'
				})
				console.log(college)
				that.college = college
			},
			gowork() {
				var that = this
				that.$refs['reg_form'].validate((valid) => {
					if (valid) {
						that.$refs['xx_form' + that.info.type].validate((valid) => {
							if (valid) {
								that.$router.push({
									name: 'Work'
								})
							} else {
								that.$message.error('请先完成注册~')
								return false
							}
						})
					} else {
						that.$message.error('请先完成注册~')
						return false
					}
				})
			},
			gocer() {
				var that = this
				that.$router.push({
					name: 'Cer'
				})
			}
		},

	}
</script>

<style>
	.index.nobg {
		background: #FFFFFF;
	}

	.main_body {
		background-color: #F5F5F5;
	}

	.left_mune {
		width: 190px;
		float: left;
		overflow: hidden;
		margin-top: 2px;
		background-color: #FFF;
	}

	.left_mune ul {
		margin: 0;
		padding: 0;
		display: block;
	}

	.left_mune li {
		width: 168px;
		height: 82px;
		text-align: center;
		list-style: none;
		display: block;
		overflow: hidden;
		border-left: #4e4e4e 4px solid;
		margin: 18px 0 18px 18px;
		font-size: 16px;
		font-weight: 400;
		color: #4e4e4e;
		cursor: pointer;
		line-height: 82px;
	}

	.left_mune li img {
		width: 30px;
		height: 30px;
		display: inline-block;
		margin-bottom: -5px;
	}

	.left_mune li.active {
		border-left: #a17c23 4px solid;
		background-color: #ba953a;
		color: #FFFFFF;
	}

	.main_content {
		float: right;
		width: 1090px;
		overflow: hidden;
	}

	.main_content h1 {
		font-size: 24px;
		font-weight: 400;
		padding-left: 45px;
	}

	.main_content_g {
		width: 960px;
		overflow: hidden;
		background-color: #FFF;
		margin: 20px 45px;
		padding: 20px;
		border-radius: 10px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1)
	}

	.button_2 {
		display: block;
		width: 100px;
		height: 28px;
		text-align: center;
		line-height: 28px;
		border-radius: 15px;
		border: #bd9639 1px solid;
		font-size: 14px;
		font-weight: 400;
		color: #bd9639;
		cursor: pointer;
	}

	.button_1 {
		display: block;
		width: 100px;
		height: 30px;
		text-align: center;
		line-height: 30px;
		border-radius: 15px;
		font-size: 14px;
		font-weight: 400;
		background-color: #bd9639;
		color: #FFF;
		cursor: pointer;
	}

	.avatar-upload-box {
		width: 160px;
		height: 160px;
		display: block;
		margin: 20px auto;
	}

	.avatar-upload-box img {
		width: 120px;
		height: 120px;
		display: block;
		border-radius: 60px;
	}

	.avatar-upload-box span {
		font-size: 12px;
		color: #bbbbbb;
	}

	.college_tishi {
		display: block;
		color: #ba953a;
		font-size: 12px;
		cursor: pointer;
	}

	.college_tishi i {
		font-size: 14px;
	}
</style>